<template>
  <div>
    <v-sheet class="mt-2" v-if="loading">
      <v-skeleton-loader class="mx-auto" type="table-tbody"></v-skeleton-loader>
    </v-sheet>
    <v-simple-table dense v-else class="bordered--table elevation-4">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">#</th>
            <th :colspan="listOfCustomerPriorities ? listOfCustomerPriorities.length : 0" class="text-left">
              <v-layout>
                <v-flex xs6>
                  {{ $t('message.discountGrp.customerGroup') }}
                </v-flex>
                <v-flex xs6 class="text-right">
                  <v-btn x-small fab @click="openDialogHandler">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ $t('message.customer.productGroup') }}</td>
            <td v-for="group in listOfCustomerPriorities" :key="group.id">
              {{ group.name }}
            </td>
          </tr>
          <tr v-for="product in listOfMatrices" :key="product.id">
            <td width="20%">{{ product.number ? product.number + ' - ' : '' }}  {{ product.name }}</td>
            <td v-for="priority in product.priorties" :key="priority.id">
              <v-text-field v-model="priority.discount" @change="saveMatrixValue(priority.record_id, product.id, priority.id, priority.discount)" dense hide-details></v-text-field>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-dialog v-model="dialog" width="750" persistent>
      <form-template :references.sync="formReferences" :model="modelObj" ref="fieldsReference"></form-template>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FormTemplate from '@/components/FormTemplate'
export default {
  data () {
    return {
      MODULE_URL: 'discountgroups',
      loading: false,
      modelObj: {},
      dialog: false,
      fieldsLoading: false,
      listOfMatrices: []
    }
  },
  computed: {
    ...mapState(['FORM_TYPE', 'listOfProductGroups', 'listOfCustomerPriorities']),
    formReferences () {
      return {
        title: this.modelObj.id ? this.$t('message.priority.updatePriority') : this.$t('message.priority.addPriority'),
        properties: [{
          model: 'name',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.customer.name'),
          class: 'xs6'
        }, /* {
          model: 'position',
          rules: [],
          type: this.FORM_TYPE.NUMBER,
          class: 'xs6',
          label: this.$t('message.common.position')
        },  */{
          model: 'isactive',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'xs3 my-auto',
          label: this.$t('message.common.isActive')
        }, {
          model: 'isdefault',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'xs3 my-auto',
          label: this.$t('message.common.isDefault')
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.modelObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.saveUpdateHandler,
          loading: this.loading,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closeDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    }
  },
  components: {
    FormTemplate
  },
  created () {
    this.getAllListvalues()
  },
  methods: {
    getAllListvalues () {
      this.$store.dispatch('getProductGroups')
        .then(() => {
          this.$store.dispatch('getCustomerPriority')
            .then(() => {
              this.getMatrixValues()
            })
        })
    },
    saveMatrixValue (recordId, productId, priorityId, discount) {
      let model = { id: recordId || 0, group_id: productId, customerpriority_id: priorityId, discount: this.$formatter.replaceCommaWithDot(discount) }
      this.$_executeApi('post', 'discountgroups', model)
        .then((response) => {
          if (response.data) {
            this.getMatrixValues()
          }
        })
    },
    getMatrixValues () {
      this.$_executeApi('get', 'discountgroups')
        .then((response) => {
          if (response.data) {
            let getMatricsList = response.data
            let getDiscountMatrixList = this.$formatter.cloneVariable(this.listOfProductGroups)
            let getPriorities = this.$formatter.cloneVariable(this.listOfCustomerPriorities)
            getDiscountMatrixList.map(x => {
              x['priorties'] = getPriorities.map(y => {
                let item = this.$formatter.cloneVariable(y)
                let getMatrixData = getMatricsList.find(z => z.group_id === x.id && z.customerpriority_id === item.id)
                item['discount'] = getMatrixData ? this.$formatter.replaceDotWithComma(getMatrixData.discount) : ''
                item['record_id'] = getMatrixData ? getMatrixData.id : ''
                return item
              })
              return x
            })
            this.listOfMatrices = getDiscountMatrixList
          }
        })
    },
    openDialogHandler () {
      this.dialog = true
      this.modelObj = { isactive: true }
    },
    closeDialogHandler () {
      this.dialog = false
      this.modelObj.id = undefined
      this.$refs.fieldsReference.$refs.validateForm.reset()
    },
    saveUpdateHandler () {
      if (this.$refs.fieldsReference.$refs.validateForm.validate()) {
        this.fieldsLoading = true
        let model = this.modelObj
        model.position = model.position || null
        let url = 'customerpriorities'
        this.$_saveUpdateHandler(url, model)
          .then(() => {
            this.closeDialogHandler()
            this.getAllListvalues()
          })
          .finally(() => {
            this.fieldsLoading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    }
  }
}
</script>
